<footer>
  MyGolfStat {{app_version ? 'v.' + app_version : ''}} © 2021
</footer>
